// extracted by mini-css-extract-plugin
export default {"table":"SentEmailTable_table__XCPOg","sentDate":"SentEmailTable_sentDate__2liWq","subject":"SentEmailTable_subject__581lF","body":"SentEmailTable_body__PfUXi"};